module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "feature-area section-padding2",
    attrs: {
      "id": _vm.id
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "section-top text-center"
  }, [_c('h2', {
    class: _vm.id == "yewujieshao" ? "title borderCDE" : "title",
    staticStyle: {
      "z-index": "100",
      "position": "relative"
    }
  }, [_vm._v(_vm._s(_vm.introduceInfo[0].title))]), _vm._v(" "), _c('p', {
    staticClass: "titleShadow",
    staticStyle: {
      "z-index": "0"
    }
  }, [_vm._v(_vm._s(_vm.introduceInfo[0].subTitle))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "background-color": "#b32121",
      "display": "flex",
      "border-radius": "8px",
      "align-items": "center",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "color": "#fff",
      "box-sizing": "border-box",
      "padding": "10px 20px"
    }
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.introduceInfo[0].content)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.introduceInfo[0].titleImage,
      "alt": "古都旅游"
    }
  })])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2d6295f4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/module/introduceEctypal.vue
// module id = 98
// module chunks = 1